/**
 * @generated SignedSource<<6bf0b0e3c115bcd040dfea792b67865f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutPayPalView_payPalAccount$data = {
  readonly displayName: string | null;
  readonly email: string | null;
  readonly " $fragmentType": "CheckoutPayPalView_payPalAccount";
};
export type CheckoutPayPalView_payPalAccount$key = {
  readonly " $data"?: CheckoutPayPalView_payPalAccount$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutPayPalView_payPalAccount">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutPayPalView_payPalAccount",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    }
  ],
  "type": "PayPalAccount",
  "abstractKey": null
};

(node as any).hash = "f1998c641f26250ad8dc6c16f750e801";

export default node;
